import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Form from 'modules/core/components/Form'
import FormRow from 'modules/core/components/FormRow'
import Text from 'modules/core/components/Inputs/Text'
import PanesHeader from 'modules/core/components/PanesHeader'
import PanesPadForm from 'modules/core/components/PanesPadForm'
import asyncAction from 'modules/core/lib/asyncAction'
import { useFeatures } from 'modules/core/hooks/useFeatures'
import i18n from 'modules/core/lib/i18n'
import type LegalEntity from 'modules/core/store/models/LegalEntity'

import CompanyIBANForm from 'modules/settings/lib/forms/IBAN'

interface Props {
  legalEntity: LegalEntity
}

const Iban: React.FC<Props> = ({ legalEntity }) => {
  const { has_payroll: hasPayroll } = useFeatures(['payroll'])
  const ibanForm = new CompanyIBANForm(legalEntity.toJS())

  const onSubmitIBAN = () => {
    return asyncAction(() => ibanForm.save(legalEntity))
  }

  return (
    <PanesPadForm direction="horizontal" boxed>
      <PanesHeader
        illustration="credit-card"
        title={i18n.t('settings.edit_company.iban_form.title')}
        description={i18n.t('settings.edit_company.iban_form.description')}
      />
      <Form onSubmit={onSubmitIBAN}>
        <FormRow>
          <Text
            mandatory={hasPayroll && !ibanForm.get('bank_account').value}
            label={i18n.t('settings.edit_company.iban_form.fields.bank_account')}
            field={ibanForm.get('bank_account')}
          />
        </FormRow>
        <FormRow>
          <Text
            mandatory={hasPayroll && !ibanForm.get('swift').value}
            label={i18n.t('settings.edit_company.iban_form.fields.swift')}
            field={ibanForm.get('swift')}
          />
        </FormRow>
        {ibanForm.isDirty && (
          <FormRow footer>
            <Button submit>{i18n.t('common.submit')}</Button>
          </FormRow>
        )}
      </Form>
    </PanesPadForm>
  )
}

export default observer(Iban)
